var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable max-depth */
import WebStorageCache from '@byted/uc-secure-cache';
import CryptoSDK, { processRequestConfig, processResponseConfig, convertBase64ToString, convertHexToBase64, convertStringToBase64, } from '@byted/uc-secure-crypto';
import { requestHooks } from '@byted/uc-secure-request-hooks';
var SecuritySDK = /** @class */ (function () {
    function SecuritySDK(params) {
        var _this = this;
        /**
         * 尽量避免使用这个方法，目前可信只维护一套公私钥 如果刷新的话 多个业务同时初始化就会有问题 后续会改进
         * @returns void, multi Instance do not use this api because if you refresh the keys & certificate should be refresh
         */
        this.refresh = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cryptoSDK.refresh()];
            });
        }); };
        var aid = params.aid, scene = params.scene, _a = params.certType, certType = _a === void 0 ? 'header' : _a;
        // init cache sdk
        this._cacheSDK = new WebStorageCache();
        var cacheProps;
        if (this._cacheSDK.isSupport()) {
            cacheProps = {
                get: this._cacheSDK.get,
                set: this._cacheSDK.set,
                delete: this._cacheSDK.delete,
            };
        }
        // crypt sdk init
        this.cryptoSDK = new CryptoSDK({ aid: aid, scene: scene, cacheSDK: cacheProps, certType: certType });
        var proxy = params.proxy;
        // request hooks
        if ((typeof proxy === 'boolean' && proxy) || typeof proxy === 'function') {
            requestHooks(__assign(__assign({}, params), { crypt: this.cryptoSDK }), '1');
        }
    }
    return SecuritySDK;
}());
export default SecuritySDK;
export { processRequestConfig, processResponseConfig, convertBase64ToString, convertStringToBase64, convertHexToBase64, };
